module.exports = __webpack_public_path__ + "static/media/person-holding-flag-herdy.00e97ec9.svg";